import {Component, computed, inject, Injectable, Input, Signal, signal, WritableSignal} from '@angular/core';
import {MatRadioChange, MatRadioModule} from '@angular/material/radio';
import {SearchFilterMap, SearchIndexName} from '@models/search';
import {SearchBarComponent} from '../../search-bar/search-bar.component';
import {Filter, FilterSelection, FilterVisibility} from '../filter';

const validValues: Record<string, string> = {Projects: 'Projects', Datasets: 'Datasets'};

@Component({
  template: `<ul class="bulletless">
    @for (v of validKeys; track v) {
      <li>
        <mat-radio-button
          name="index"
          [value]="v"
          [checked]="filter.selectedValues()[0] === v"
          (change)="changeSelection($event)"
          >{{ validValues[v] }}</mat-radio-button
        >
      </li>
    }
  </ul>`,
  imports: [MatRadioModule],
})
class IndexPicker {
  @Input() filter: DataSearchIndexFilter;
  protected searchBar = inject(SearchBarComponent);

  validValues = validValues;
  validKeys = Object.keys(validValues);

  changeSelection($event: MatRadioChange) {
    this.filter.selectedValues.set([$event.value]);
    this.searchBar.index = $event.value;
    this.searchBar.recordType = $event.value.toLowerCase();
    this.searchBar.indexChange.emit($event.value);
    this.searchBar.searchInitialResults();
  }
}

@Injectable()
export class DataSearchIndexFilter implements Filter<SearchIndexName> {
  key = 'index';
  label = 'Type';
  component = IndexPicker;
  visibility = FilterVisibility.EVERYONE;
  selectedValues: WritableSignal<string[]> = signal(['Projects']);
  selected: Signal<FilterSelection[]> = computed(() => this.selectedValues().map(value => ({label: value, value})));
  defaultExpanded = false;

  load(values: string[]): void {
    const valid = values.filter(v => v === 'Projects' || v === 'Datasets');
    if (valid.length > 0) {
      this.selectedValues.set([valid[0]]);
    } else {
      this.selectedValues.set(['Projects']);
    }
  }

  apply(filterBody: SearchFilterMap[SearchIndexName]): void {
    // Index selection is handled by the search bar's index input, not the filter body
  }

  remove(value: string): void {
    // Reset to default when removed
    this.selectedValues.set(['Projects']);
  }
}
